<template>
    <div>
        <div class="card-title">
            <b-button @click="$emit('back');" size="sm"><i class="fas fa-arrow-left"></i></b-button>
            {{notificationGroupName}}
        </div>
        <b-alert variant="success" :show="display_items.length == 0">
            No new notices
        </b-alert>
        <webix-ui v-if="showTable"
            :config="ui"
            :data="display_items"
        >
        </webix-ui>
    </div>
</template>

<script>
import _ from 'lodash'
export default {
    data:() => ({
        showTable: false,
        ui:{
            view: 'datatable',
            id: window.webix.uid(),
            select: 'row',
            autoheight: true,
            fillspace: true,
            columns: [
                {id:'id'},
                { id: 'actions', header: 'Actions',
                    template:function(){
                        return `<button class="btn-primary btn-view btn-sm btn">View</button>`
                    }
                },
                { id: 'type', header: 'Type', format(value){
                    switch(value){
                        case 'read_sop':{
                            return 'Read SOP'
                        }
                        default:{
                            return value;
                        }
                    }
                } },
                { id: 'sop_name', header: 'Name', fillspace: 1},
                { id: 'sop_code', header: 'Sop Code', fillspace: 1},
                { id: 'published_date', header: 'Published Date', fillspace: 1},
            ],
            onClick:{
                'btn-view':function(a,b){
                    a.preventDefault();
                    let item = this.getItem(b);
                    let el = this.$scope.$parent;
                    let data = {
                        group_id: item.sop_group_id,
                        id: item.sop_type_id,
                        action_id: item.id,
                    }
                    el.$emit('selectedDocument', data);
                }
            },
            data: [],
        }
    }),
    props:{
        group_notifications:{},
        index:{},
    },
    components:{},
    computed:{
        display_items(){
            if(this.group_notifications == null){
                return [];
            }
            else{
                let data = _.cloneDeep(this.group_notifications);
                //data = _.uniqBy(data, ['id', 'type']);
                return data;
            }
        },
        notificationGroupName(){
            let name = '';
            if(this.index == 0){
                name = "Document";
            }
            if(this.index == 1){
                name = "Facility";
            }
            if(this.index == 2){
                name = "Training";
            }
            if(this.index == 3){
                name = "Action";
            }
            name += ' Alerts';
            return name;
        }
    },
    watch:{
        group_notifications(){
            this.updateData();
        }
    },
    methods:{
        updateData(){
            this.showTable = false;
            this.ui.data = this.display_items;
            this.$nextTick(()=>{
                this.showTable = true;
            });
        }
    },
    mounted(){
        this.updateData();
    },
}
</script>

<style>

</style>